import { render, staticRenderFns } from "./ResearchLink.vue?vue&type=template&id=8268a9c8&scoped=true"
import script from "./ResearchLink.vue?vue&type=script&lang=js"
export * from "./ResearchLink.vue?vue&type=script&lang=js"
import style0 from "./ResearchLink.vue?vue&type=style&index=0&id=8268a9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8268a9c8",
  null
  
)

export default component.exports